export const OPT_CATEGORY = ['305', '306'];

export const CUT_CATEGORY_ID_REQUIRED = {
  winding: ['305', '306'],
  cutting: ['309', '311', '312', '313', '314'],
  roman: ['902'],
};

// перечисления категорий из parameters.category
export const CUT_CATEGORY_WINDING_GROUP = {
  cutting: [
    {
      id: '310',
      name: 'Ткани плиссе/гофре',
    },
  ],
  winding: [
    {
      id: '297',
      name: 'Рулонные шторы',
    },
    {
      id: '306',
      name: 'Ткани ЗЕБРА',
    },
  ],
  roman: [
    {
      id: '315',
      name: 'Римские шторы',
    },
  ],
};

export const DELIVERY_METHOD = {
  TRANSPORT: {
    code: 'transport',
  },
  ADDRESS: {
    code: 'address',
  },
  PICKUP: {
    code: "pickup"
  }
};
